module.exports = __webpack_public_path__ + "static/img/icon-person.04e397e8.svg";